exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wfh-custom-select-item[data-v-2773e6ab]{padding:4px 15px;height:40px;align-items:center}.wfh-custom-select-item rect[data-v-2773e6ab]{fill:#000}.wfh-custom-select-item i[data-v-2773e6ab]{color:#000}.wfh-custom-select-item[data-v-2773e6ab]:hover{color:#fff;background-color:#3592ff}.wfh-custom-select-item:hover i[data-v-2773e6ab]{color:#fff}.wfh-custom-select-item:hover rect[data-v-2773e6ab]{fill:#fff}", ""]);

// exports
